import React from "react";

import { PageHeader, Button, Statistic, Descriptions, Divider, Row, Card, Popconfirm } from "antd";

import InvoiceSteps from "./steps";
import Details from "./details";
import { INVOICE_STATUS_ACCEPTED, INVOICE_STATUS_IN_REVIEW } from "../../../../../config/const";

const Content = ({ children, extra }) => {
    return (
        <div className="content">
            <div className="main">{children}</div>
            <div className="extra">{extra}</div>
        </div>
    );
};

export default class Show extends React.Component {
    constructor(props) {
        super(props);
        this.state = { id: props.match.params.id };
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    _handleAccepted = () => {
        this.props.accepted(this.state.id);
    };

    renderContent = (column = 2) => {
        const { data } = this.props;

        return (
            <>
                <Descriptions size="small" column={1}>
                    <Descriptions.Item label="Client">
                        {data.invoice.client ? data.invoice.client.name : ""}
                    </Descriptions.Item>
                </Descriptions>
            </>
        );
    };

    extraContent = () => (
        <div
            style={{
                display: "flex",
                width: "max-content",
                justifyContent: "flex-end",
            }}
        >
            <Statistic title="Status" value={this.props.data.invoice.status} style={{ marginRight: 32 }} />
            <Statistic title="Price" prefix="$" value={this.props.data.invoice.amountValue} />
        </div>
    );

    render() {
        const { data } = this.props;

        return (
            <div style={{ marginBottom: 20 }}>
                <div>
                    <PageHeader
                        ghost={false}
                        avatar={{ icon: "I" }}
                        className="site-page-header"
                        onBack={this._goBack}
                        title={data.invoice?.number}
                        subTitle="Invoice"
                        extra={[
                            data.invoice.status === INVOICE_STATUS_IN_REVIEW && (
                                <Popconfirm
                                    title="Are you sure?"
                                    onConfirm={this._handleAccepted}
                                    okText="Yes"
                                    cancelText="No"
                                    disabled={this.props.actionLoading}
                                >
                                    <Button type="primary" size="small" disabled={this.props.actionLoading}>
                                        <i className="fa fa-pencil-square-o"></i>
                                        <Divider type="vertical" />
                                        Accepted
                                    </Button>
                                </Popconfirm>
                            ),
                            //data.invoice.status === INVOICE_STATUS_ACCEPTED && <h3>revertir?</h3>,
                        ]}
                    >
                        <InvoiceSteps status={data.invoice.status} />
                        <Content extra={this.extraContent()}>{this.renderContent()}</Content>
                    </PageHeader>
                </div>
                <br />

                <PageHeader ghost={false}>
                    <Details {...this.props} />
                    <br />
                </PageHeader>
            </div>
        );
    }
}
